import { useHasPolicy } from './useHasPolicy';

export const READ_ONLY_POLICY = 'app-api-vp-digital.anwendung.lesen';

export const useReadOnlyMode = (): boolean => useHasPolicy(READ_ONLY_POLICY);
